export const trackEventSendInBlue = (eventName, properties, eventData) => {
    window.sendinblue.track(
        eventName,
        properties,
        eventData
    );
}
